import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { Lock, ArrowLeft } from 'lucide-react';
import Button from '@/components/atoms/Button';

const ComingSoon = ({ title = 'Coming Soon', description, backTo = '/', backLabel = 'Home' }) => (
  <>
    <Helmet>
      <title>{`${title} | DrkLynX`}</title>
      <meta name="description" content={description || `${title} — coming soon to DrkLynX.`} />
    </Helmet>
    <div className="min-h-[60vh] flex flex-col items-center justify-center text-center px-6">
      <div className="w-16 h-16 rounded-xl border border-cyan/20 bg-cyan/5 flex items-center justify-center mb-6">
        <Lock className="w-7 h-7 text-cyan" />
      </div>
      <h1 className="font-heading font-bold text-2xl sm:text-3xl text-signal mb-2">{title}</h1>
      <p className="text-steel max-w-md mb-8">{description || 'This section is under construction. Check back soon.'}</p>
      <Link to={backTo}>
        <Button variant="secondary" size="sm">
          <ArrowLeft className="w-4 h-4" /> {backLabel}
        </Button>
      </Link>
    </div>
  </>
);

export default ComingSoon;
